var map = {
	"./2015_0.webp": "1402",
	"./2015_1.webp": "c613",
	"./2016_0.webp": "f1b4",
	"./2016_1.webp": "2221",
	"./2017_0.webp": "4e6e",
	"./2017_1.webp": "4191",
	"./2018_0.webp": "7ca7",
	"./2018_1.webp": "1a08",
	"./2019_0.webp": "01f0",
	"./2019_1.webp": "e789",
	"./2020_0.webp": "a900",
	"./2020_1.webp": "ac1f6",
	"./2021_0.webp": "e865",
	"./2021_1.webp": "4767",
	"./2022_0.webp": "4a4d",
	"./2022_1.webp": "e376",
	"./2023_0.webp": "db8c",
	"./2023_1.webp": "c928",
	"./2024_0.webp": "6491",
	"./2024_1.webp": "e01f",
	"./2025_0.webp": "d884",
	"./2025_1.webp": "e95c",
	"./2026_0.webp": "06d6",
	"./2026_1.webp": "c87b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8597";